(function($) {
	
	var $block = $('.wp-block-metropolis-featured-events');
	
	$block.each( function() {
	
		$(this).addClass('swiper').append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>').children('.slides').addClass('swiper-wrapper').children().addClass('swiper-slide').ready(function () {
			
			const carousel = new Swiper('.wp-block-metropolis-featured-events', {
				
				autoplay: {
					delay: 5000,
					disableOnInteraction: true,
				},
				speed: 0,
				slidesPerView: 1,
    			containerModifierClass: 'carousel-',
				loop: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				
			});
			
		});
	
	});
	
})(jQuery);